/* eslint-disable react/jsx-no-comment-textnodes */
import React from "react";
import "../styles/info.css";
import MertPhoto from "../assets/images/MertFoto.jpg";
import { useFilter } from "../context/FilterContext";
import BioInfoPanel from "./InfoPanels/BioInfoPanel";
import InterestsPanel from "./Panels/InterestsPanel";
import ExperiencePanel from "./Panels/ExperiencePanel";
import IndexJSPanel from "./Panels/IndexJSPanel";
import MeReadPanel from "./Panels/MeReadPanel";
import InterestsInfoPanel from "./InfoPanels/InterestsInfoPanel";
import ExpertiseInfoPanel from "./InfoPanels/ExpertiseInfoPanel";

const InfoPanel = () => {
  const { selectedFilter } = useFilter();

  const fileInfo = () => {
    if (selectedFilter === "bio") {
      return <BioInfoPanel />;
    } else if (selectedFilter === "interests") {
      return <InterestsInfoPanel />;
    } else if (selectedFilter === "experience") {
      return <ExpertiseInfoPanel />;
    } else if (selectedFilter === "index.js") {
      return null;
    } else if (selectedFilter === "README.md") {
      return null;
    }
  };

  return <div className="panel">{fileInfo()}</div>;
};

export default InfoPanel;
